module.exports = __webpack_public_path__ + "static/media/h4g2.c1623372.png";